import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LandlordState } from './landlords.reducers';

const getLandlordState = createFeatureSelector<LandlordState>('editLandlord');

export const getCRUDActionState = createSelector(
  getLandlordState,
  state => state.CRUDActionState
);

export const getLandlordActionState = createSelector(
  getLandlordState,
  state => state.landlordActionState
);

export const getSelectedLandlordId = createSelector(
  getLandlordState,
  state => state.selectedLandlordId
);

export const getLandlord = createSelector(
  getLandlordState,
  state => state.landlord
);

export const getNextProductId = createSelector(
  getLandlordState,
  state => state.nextProductId
);

export const getCurrentStepNumber = createSelector(
  getLandlordState,
  state => state.currentStepNumber
);

export const getCompletedStep = createSelector(
  getLandlordState,
  state => state.completedSteps
);

export const getObjectHierarchy = createSelector(
  getLandlordState,
  state => state.objectHierarchyData
);

export const getCustomerImportSettings = createSelector(
  getLandlordState,
  state => state.customerImportSettings
);

export const getObjectHierarchyLoadingStatus = createSelector(
  getLandlordState,
  state => state.objectHierarchyActionState.pending
);

export const getObjectHierarchyActionState = createSelector(
  getLandlordState,
  state => state.objectHierarchyActionState
);

export const getCustomerImportSettingsActionState = createSelector(
  getLandlordState,
  state => state.customerImportSettingsActionState
);
